import React, { useState } from 'react'
import { PencilSimpleLine } from '@phosphor-icons/react'
import { convertToLocal, convertToUtc } from 'helper/utility'
import './styles.scss'
import moment from 'moment'
import { useUpdateCheckInCheckOutTime } from 'api/Event/Attendance'
import ButtonSpinner from 'components/global/ButtonSpinner'

interface HistoryTimeProps {
  time: string
  isCheckIn: boolean
  checkInId: string
}

const HistoryTime: React.FC<HistoryTimeProps> = ({
  time,
  isCheckIn,
  checkInId,
}) => {
  const [showUpdateTime, setShowUpdateTime] = useState(false)
  const { mutate: updateCheckInCheckOutTime, isLoading } =
    useUpdateCheckInCheckOutTime()

  // Parse time to hour, minute, ampm
  const localTime = convertToLocal(time, 'hh:mm A')
  const [hour, setHour] = useState(localTime.split(':')[0])
  const [minute, setMinute] = useState(localTime.split(':')[1].split(' ')[0])
  const [ampm, setAmpm] = useState(localTime.split(' ')[1])

  const handleCancel = () => {
    setHour(localTime.split(':')[0])
    setMinute(localTime.split(':')[1].split(' ')[0])
    setAmpm(localTime.split(' ')[1])
    setShowUpdateTime(false)
  }
  const handleUpdate = () => {
    const baseDate = moment(time)
    let hourNum = parseInt(hour, 10)
    if (ampm === 'PM' && hourNum !== 12) hourNum += 12
    if (ampm === 'AM' && hourNum === 12) hourNum = 0
    const newMoment = baseDate.clone().set({
      hour: hourNum,
      minute: parseInt(minute, 10),
      second: 0,
      millisecond: 0,
    })

    const payload = isCheckIn
      ? { checkedInAt: moment(newMoment).utc().format() }
      : { checkedOutAt: moment(newMoment).utc().format() }

    updateCheckInCheckOutTime(
      {
        checkInId,
        payload,
      },
      {
        onSuccess: () => {
          setShowUpdateTime(false)
        },
      },
    )
  }

  return (
    <div className="flex align-center gap-20px">
      <div
        className="bg-dark-gray radius-12 flex align-center justify-center"
        style={{ width: '120px', height: '50px' }}
      >
        <p className="text-14 w-500">{convertToLocal(time, 'hh:mm A')}</p>
      </div>

      <PencilSimpleLine
        size={20}
        color="#000"
        className="pointer"
        onClick={() => setShowUpdateTime(true)}
      />

      {showUpdateTime ? (
        <div className="flex align-center justify-between w-full gap-10px">
          <div className="input-fields-container">
            <input
              type="number"
              min="1"
              max="12"
              value={hour}
              onChange={e => setHour(e.target.value)}
              className="input-time"
            />
            <input
              type="number"
              min="0"
              max="59"
              value={minute}
              onChange={e => setMinute(e.target.value)}
              className="input-time"
            />
            <select
              value={ampm}
              onChange={e => setAmpm(e.target.value)}
              className="input-time"
              style={{ width: '60px' }}
            >
              <option value="AM">AM</option>
              <option value="PM">PM</option>
            </select>
          </div>

          <div className="flex align-center gap-20">
            <button className="btn-cancel butn" onClick={handleCancel}>
              Cancel
            </button>
            <button className="btn-update butn" onClick={handleUpdate}>
              {isLoading ? <ButtonSpinner size={20} color="#000" /> : 'Update'}
            </button>
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default HistoryTime
